import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'sku-orders.dashboard.page-title',
    defaultMessage: 'Orders',
  },
  tabToday: {
    id: 'sku-orders.dashboard.tab-today',
    defaultMessage: 'Today',
  },
  tabHistory: {
    id: 'sku-orders.dashboard.tab-history',
    defaultMessage: 'History',
  },
  columnMemberName: {
    id: 'sku-orders.dashboard.column-member-name',
    defaultMessage: 'Member name',
  },
  columnOrderId: {
    id: 'sku-orders.dashboard.column-order-id',
    defaultMessage: 'Order ID',
  },
  columnItem: {
    id: 'sku-orders.dashboard.column-item',
    defaultMessage: 'Item',
  },
  columnPayout: {
    id: 'sku-orders.dashboard.column-payout',
    defaultMessage: 'Payout',
  },
  columnPickupDate: {
    id: 'sku-orders.dashboard.column-pickup-date',
    defaultMessage: 'Pickup date',
  },
  columnPickupTime: {
    id: 'sku-orders.dashboard.column-pickup-time',
    defaultMessage: 'Pickup time',
  },
  columnStatus: {
    id: 'sku-orders.dashboard.column-status',
    defaultMessage: 'Status',
  },
  lifecycleStatusFilterLabel: {
    id: 'sku-orders.dashboard.lifecycle-status-filter-label',
    defaultMessage: 'Order status',
  },
  lifecycleStatusCancelled: {
    id: 'sku-orders.dashboard.lifecycle-status-cancelled',
    defaultMessage: 'Cancelled',
  },
  markFulfilled: {
    id: 'sku-orders.dashboard.mark-fulfilled',
    defaultMessage: 'Mark as fulfilled',
  },
  emptyOrders: {
    id: 'sku-orders.dashboard.empty-orders',
    defaultMessage: 'No orders found.',
  },
  emptyOrdersSubtitle: {
    id: 'sku-orders.dashboard.empty-orders-subtitle',
    defaultMessage: 'Your new orders will appear here as ClassPass{br}members book them.',
  },
  emptyIcon: {
    id: 'sku-orders.dashboard.empty-icon',
    defaultMessage: 'No orders icon',
  },
  settingsButton: {
    id: 'sku-orders.dashboard.settings-button',
    defaultMessage: 'Settings',
  },
  manageItems: {
    id: 'sku-orders.dashboard.manage-items',
    defaultMessage: 'Manage items',
  },
  businessProfile: {
    id: 'sku-orders.dashboard.business-profile',
    defaultMessage: 'Business Profile',
  },
  fulfillOrderError: {
    id: 'sku-orders.dashboard.fulfill-order-error',
    defaultMessage: 'Failed to mark order as fulfilled. Please try again.',
  },
  loadOrdersError: {
    id: 'sku-orders.dashboard.load-orders-error',
    defaultMessage: 'Failed to load orders. Please try again.',
  },
  orderActionsMenu: {
    id: 'sku-orders.dashboard.order-actions-menu',
    defaultMessage: 'Order actions',
  },
  orderActionEditOrder: {
    id: 'sku-orders.dashboard.order-action-edit-order',
    defaultMessage: 'Edit order',
  },
  orderActionCustomerMissedPickup: {
    id: 'sku-orders.dashboard.order-action-customer-missed-pickup',
    defaultMessage: 'Customer missed pickup',
  },
  cancelOrderError: {
    id: 'sku-orders.dashboard.cancel-order-error',
    defaultMessage: 'We were unable to cancel this order',
  },
  cancelOrderModalTitle: {
    id: 'sku-orders.dashboard.cancel-order-modal-title',
    defaultMessage: 'Confirm and notify customer',
  },
  cancelOrderSubject: {
    id: 'sku-orders.dashboard.cancel-order-subject',
    defaultMessage: 'Your order from {venueName} was cancelled',
  },
  cancelOrderCreditsRefundWithAmount: {
    id: 'sku-orders.dashboard.cancel-order-credits-refund-with-amount',
    defaultMessage: 'the {creditAmountTotal} credits',
  },
  cancelOrderCreditsRefundWithoutAmount: {
    id: 'sku-orders.dashboard.cancel-order-credits-refund-without-amount',
    defaultMessage: 'the credits',
  },
  cancelOrderMessage: {
    id: 'sku-orders.dashboard.cancel-order-message',
    defaultMessage:
      "{greeting}<br /><br />Your {venueName} order for {dateTimeHtml} has been cancelled.<br /><br />We''ve returned {creditsRefundPhrase} used to place your order back to your account so you can reorder at another time.<br /><br />{reorderNowLink}<br /><br />Our apologies for any inconvenience.<br /><br />Sincerely,<br />The ClassPass Team",
  },
  cancelOrderSuccess: {
    id: 'sku-orders.dashboard.cancel-order-success',
    defaultMessage: 'Order cancelled',
  },
  cancelOrderSuccessWithNotification: {
    id: 'sku-orders.dashboard.cancel-order-success-with-notification',
    defaultMessage: 'Order cancelled and customer notified',
  },
  newOrdersReceived: {
    id: 'sku-orders.dashboard.new-orders-received',
    defaultMessage: '{count, plural, one {# new order received} other {# new orders received}}',
  },
});
